<template>
	<div class="skrzynia" v-show="show">
		<div class="stitle"> {{ title }} </div>
		<div>
			<div class="nazwa"> {{ nazwa }} </div>
			<div class='wrap'>
    				<ejs-numerictextbox v-if="ident == 0" id="skrzynia" :value="skr" format="###" :min="0" cssClass="e-style"></ejs-numerictextbox>
    				<ejs-numerictextbox v-if="ident != 0" :id="getIdSkrzyni()" :value="skr" format="###" :min="0" cssClass="e-style"></ejs-numerictextbox>
			</div>
		</div>
	</div>
</template>

<script>

import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";

export default {
  name: "skrzynia",
  components: { 
        "ejs-numerictextbox": NumericTextBoxComponent,
  },
  props: {
    nazwa: String,
    ident: Number,
    dataLoading: Boolean,
    skr: Number,
  },
  data: () => ({
        title: "PODAJ ILOŚĆ SKRZYŃ",
	show: false,
  }),
  methods: {
	getIdSkrzyni() {
		return "skrzynia" + this.ident;
	},
  },
  mounted() {
	let that = this;
    	this.$root.$on("update:skrzynia", val1 => {
		if (val1 != null) {
			var vals = new String(val1);
			var ids = vals.split(",");
			//console.log("IDS: " + ids);
			//console.log("IDENT:" + that.ident);
			if (ids.includes("" + that.ident)) {
				console.log("FOUND!");
				that.show = true;
			} else {
				that.show = false;
			}
		}
    	});
  }
} 

</script>

<style>

.e-numeric.e-style .e-control.e-numerictextbox {
        color: royalblue;
        font-size: xx-large;
        border: 0px;
    }

/* csslint ignore:start */
    .e-numeric .e-input-group-icon.e-spin-up:before {
        content: "\e823";
        color: rgba(0, 0, 0, 0.54);
    }

    .e-numeric .e-input-group-icon.e-spin-down:before {
        content: "\e934";
        color: rgba(0, 0, 0, 0.54);
    }
    /* csslint ignore:end */

.skrzynia {
	margin-bottom:5%;
}

.nazwa {
}

.stitle {
	color:red;
}

.wrap {
margin: 0 auto;
width: 240px;
}

</style>




// WEBPACK FOOTER //
// src/components/Skrzynia.vue